module.exports = __webpack_public_path__ + "static/media/spinner.142750c6.gif";